import * as React from 'react';
import { connect } from 'react-redux';
import { goBack } from 'react-router-redux';
import { find } from 'lodash';
import * as minuteDiff from 'minute-diff';
import * as queryString from 'query-string';
import {
  Title,
  IconButton,
  ButtonGroup,
  RouteWrapper,
  ReservationUpdateForm,
  Permission,
} from '../../components';
import { getReservation } from '../../redux/actions/reservations';

interface Props {
  reservations: any;
  match: any;
  dispatch: Function;
}

interface State {
  id: number;
  reservation: any;
  ready: boolean;
}

class Route extends React.Component<Props, State> {
  constructor(props) {
    super(props);
    const id = parseInt(this.props.match.params.id, 10);
    this.state = {
      id,
      reservation: find(this.props.reservations.reservations, { id }) || false,
      ready: false,
    };
  }

  async componentDidMount() {
    if (
      !this.state.reservation.lastUpdated ||
      minuteDiff(this.state.reservation.lastUpdated) >= 1
    ) {
      const response = await this.props.dispatch(getReservation(this.state.id));
      this.setState({ reservation: response.data });
    }

    this.setState({ ready: true });
  }

  render() {
    const query = queryString.parse(window.location.search);
    let breadcrumbs = [
      {
        link: `/reservations/${this.props.match.params.id}`,
        text: 'Update Reservation',
      },
    ];
    if (query && query.from === 'history') {
      breadcrumbs = [
        { link: '/history', text: 'History' },
        { link: `/history/${query.start_date}`, text: 'Day View' },
        {
          link: `/reservations/${this.props.match.params.id}`,
          text: 'Update Reservation',
        },
      ];
    }
    if (query && query.from === 'availabilities') {
      breadcrumbs = [
        { link: '/availabilities', text: 'Availabilities' },
        {
          link: `/reservations/${this.props.match.params.id}`,
          text: 'Update Reservation',
        },
      ];
    }
    return (
      <RouteWrapper
        title="Update Reservation"
        requireAuth
        requirePermission="MANAGE_RESERVATIONS"
        breadcrumbs={breadcrumbs}
      >
        <div className="container">
          <div className="levels">
            <div className="level">
              <div className="level-left">
                <div>
                  <Title>{this.state.reservation.name}</Title>
                </div>
              </div>
              <div className="level-right">
                <ButtonGroup>
                  <Permission require="MANAGE_DELETIONS">
                    <IconButton
                      link={`/reservations/${this.state.id}/delete`}
                      className="is-danger"
                      icon="trash"
                    >
                      Delete
                    </IconButton>
                  </Permission>
                  <IconButton
                    icon="undo"
                    className="is-default is-pulled-right"
                    handleClick={() => {
                      this.props.dispatch(goBack());
                    }}
                  >
                    Return
                  </IconButton>
                </ButtonGroup>
              </div>
            </div>
          </div>
          <div className="columns is-centered">
            <div className="column is-12-desktop is-7-widescreen">
              {this.state.ready && (
                <ReservationUpdateForm
                  showHeading={false}
                  id={this.state.id}
                  item={this.state.reservation}
                  onUpdate={() => {
                    window.history.back();
                  }}
                />
              )}
            </div>
          </div>
        </div>
      </RouteWrapper>
    );
  }
}

const mapStateToProps = ({ reservations }) => ({
  reservations,
});

export default connect(mapStateToProps)(Route);
